type AddressLike = {
  street: string | null
  city: string | null
  postalCode: string | null
  rawAddress?: string | null
}

export function formatAddress(site: AddressLike): string {
  const parts = [site.street, site.postalCode, site.city].filter(
    (part): part is string =>
      part !== null && part !== undefined && part.trim().length > 0
  )

  if (parts.length === 0) {
    if (site.rawAddress) {
      return site.rawAddress
    }

    return ""
  }

  return parts.join(", ")
}
